module.exports = __webpack_public_path__ + "static/img/1.709c602.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/1.png
// module id = 60Oh
// module chunks = 1